export function formatNumber(value) {
    if (value === null || value === undefined) return '-';
    return Number(value).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
}

export function formatPercentage(value) {
    if (value === null || value === undefined) return '-';
    const n = Number(value);
    if (n > 999) return '+999%';
    if (n < -999) return '−999%';
    return `${n.toFixed(0)}%`;
}

export function levelLabelKey(level) {
    switch (level) {
        case 'BU': return 'business_unit_budget_history.level_bu';
        case 'BUCC': return 'business_unit_budget_history.level_bucc';
        case 'CAMPAIGN': return 'business_unit_budget_history.level_campaign';
        case 'ADGROUP': return 'business_unit_budget_history.level_adgroup';
        default: return null;
    }
}

export const LEVEL_ORDER = ['BU', 'BUCC', 'CAMPAIGN', 'ADGROUP'];

export const LEVEL_BORDER_CLASS = {
    BU: '-line',
    BUCC: '-bucc',
    CAMPAIGN: '-campaign',
    ADGROUP: '-adgroup',
};
